"use client";

import { useEffect, useRef, useState } from 'react';
import { startLoader, stopLoader } from "@/redux/features/app-slice";
import { AppDispatch } from "@/redux/store";
import React from "react";
import { useDispatch } from "react-redux";
import { RecaptchaVerifier } from "firebase/auth";
import {
    getFirebaseAuthRecaptchaVerifier,
    signInWithPhoneNumber,
    sendOTPToPhoneForSignIn,
} from "@/helpers/firebase/auth";

type LoginOtpPropType = {
    otpConfirmationResponse: any;
    phoneNumber: String;
};

interface CustomWindow extends Window {
    recaptchaVerifier: RecaptchaVerifier; // Change 'any' to the appropriate type if known
    confirmationResult: any;
}
declare var window: CustomWindow;

export default function LoginOTP({
    otpConfirmationResponse,
    phoneNumber
}: LoginOtpPropType) {
    const dispatch = useDispatch<AppDispatch>();
    const maxPinLength = 6;
    const [otpArray, setOtpArray] = useState<number[]>(Array(maxPinLength).fill(-1));
    const inpRefs = useRef<any>(null);
    const [activeInput, setActiveInput] = useState(-1);
    const [otpConfirmationResult, setOTPConfirmationResult] = useState<any>(otpConfirmationResponse);
    const [counter, setCounter] = useState<number>(0);
    const [inValidOtp, setInValidOtp] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            if (counter > 0) {
                setCounter(counter - 1);
            }
        }, 1000);
    }, [counter]);

    useEffect(() => {
        if (!window.recaptchaVerifier) {
            window.recaptchaVerifier = getFirebaseAuthRecaptchaVerifier();
        }
        window.recaptchaVerifier.verify();

    }, []);

    const handleCodeResending = () => {
        setCounter(59);
        sendOtp();
    };

    const sendOtp = async () => {
        const mobileNumber = `${phoneNumber}`;
        const appVerifier = window.recaptchaVerifier;
        await appVerifier.verify();
        const response = await sendOTPToPhoneForSignIn(mobileNumber, appVerifier);
        // 
        setOTPConfirmationResult(response);
    };

    const otpValidationMessage = (
        <div className="flex justify-start items-center mx-10 mt-2">
            <img
                className="h-13 w-25 mt-2"
                src="/images/error_icon.svg"
                alt="c-tribe"
            />
            <p className="mt-2 ml-2 text-[#CD0A0A] text-sm font-medium">
                Incorrect code, please try again.
            </p>
        </div>
    );

    const resendOtpBlock = (
        <>
            {counter === 0 ? (
                <div className="flex items-center mt-6">
                    <button
                        onClick={handleCodeResending}
                        className=" hover:text-blue-500"
                        type="button"
                    >
                        <p className="ml-1 mb-0 mt-2 text-left text-black text-sm hover:underline">
                            Resend Code
                        </p>
                    </button>
                </div>
            ) : (
                <div className="flex items-center mt-6">
                    <img
                        className="h-13 w-25 mt-2"
                        src="/images/otp_success.svg"
                        alt="c-tribe"
                    />
                    <p className="ml-1 mb-0 mt-2 text-left text-black text-sm">
                        Code resent!
                    </p>
                </div>
            )}
        </>
    );

    const handleKeyDown = (e: any, i: number) => {
        if (e.key == "Backspace") {
            let pass = otpArray
            pass[i] = -1
            setOtpArray(pass)
            setActiveInput(i - 1)
            if (i != 0) {
                let nextInput = inpRefs?.current?.[0]
                nextInput?.focus()
            } else {
                //@ts-ignore
                inpRefs?.current?.[i].blur()
            }
        }
    }

    const handleChange = (e: any, i: any) => {
        // @ts-ignore
        let v = e.nativeEvent["data"]
        let pass = otpArray
        let value = parseInt(v)

        if (!isNaN(value)) {
            if (i === pass.length - 1 && pass[pass.length - 1] !== -1) {
                let finalOTP = pass.join("")
                //@ts-ignore
                inpRefs?.current?.[i].blur()
                handleLogInWithOTP(finalOTP)
            }
            else {
                pass[i] = value
                setOtpArray(pass)
                if (i === pass.length - 1) {
                    let finalOTP = pass.join("")
                    //@ts-ignore
                    inpRefs?.current?.[i].blur()
                    handleLogInWithOTP(finalOTP)
                }
                else {
                    setInValidOtp(false)
                    setActiveInput(i + 1)
                    // Once the input finishes it focuses button which is the next element in the form
                    let nextInput = inpRefs?.current?.[i + 1]
                    nextInput?.focus()
                }

            }
        }

    }

    const handleLogInWithOTP = async (otp: any) => {
        dispatch(startLoader(""));
        let otpValid = await signInWithPhoneNumber(otpConfirmationResult, otp);
        dispatch(stopLoader());
        if (otpValid === undefined) {
            setInValidOtp(true)
            setOtpArray(Array(maxPinLength).fill(-1))
            setActiveInput(0)
            let nextInput = inpRefs?.current?.[0]
            nextInput?.focus()
        }
        else {
            setInValidOtp(false)
        }
    }

    return (
        <>
            <div className='flex flex-col justify-center items-center mb-4'>

                <form ref={inpRefs} >
                    <div className='flex space-x-3 mb-0 mt-8'>
                        {otpArray.map((digit, i) => (
                            <div key={i} className={`w-[45px] h-[45px] relative rounded-[5px] overflow-hidden bg-black ${activeInput == i ? "border border-gray-500" : "border border-white"}`}>
                                <label htmlFor={`pin_${i}`} className={`absolute flex justify-center items-center text-2xl text-black top-0 left-0 w-[45px] h-[45px] opacity-100`}>{digit !== -1 ? digit : ""}</label>
                                <input
                                    onFocus={() => setActiveInput(i)}
                                    onBlur={() => setActiveInput(-1)}
                                    onKeyDown={(e) => handleKeyDown(e, i)}
                                    onChange={(e) => handleChange(e, i)}
                                    className='w-full h-full text-center border-none outline-none' id={`pin_${i}`}
                                    value={digit !== -1 ? digit : ""}
                                ></input>

                            </div>
                        ))}

                    </div>
                    {inValidOtp && otpValidationMessage}

                </form>

                {resendOtpBlock}
            </div>
        </>
    );
}
